/* Pas de produit seul sur sa ligne. — L'Établi, 07/09/2026

   Les grilles de la page d'accueil sont en auto-fit : le navigateur decide
   combien de cartes tiennent, et ce nombre ne correspond pas au reglage de la
   section. Selon la largeur de la fenetre, une section de 5 produits tombe en
   4 + 1, une section de 4 en 3 + 1 : une carte reste seule sur sa ligne.

   Une regle CSS figee ne suffit pas -- il faudrait connaitre a la fois le
   nombre de produits et le nombre de colonnes, qui changent d'une section a
   l'autre et d'une largeur a l'autre. On mesure donc apres le rendu.

   Sur decision de Nathan (07/09) : la carte orpheline est masquee.
   Elle n'est PAS retiree du catalogue -- elle reste dans sa collection et
   dans la recherche. Elle ne disparait que de cette vitrine, et seulement
   aux largeurs ou elle serait seule.

   Une grille en carrousel (mobile, classe « slider ») n'est jamais touchee :
   toutes ses cartes sont sur une meme ligne et defilent.
*/
(function () {
  'use strict';
  var MARQUE = 'letabli-orphelin';

  function ranger() {
    document.querySelectorAll('.product-grid').forEach(function (grille) {
      var cartes = Array.prototype.filter.call(grille.children, function (n) {
        return n.nodeType === 1;
      });
      // on rend tout visible avant de recompter, sinon la mesure precedente
      // fausse la suivante (une carte masquee ne compte plus dans sa ligne)
      cartes.forEach(function (c) { c.classList.remove(MARQUE); });
      if (cartes.length < 3) return;

      // en carrousel, tout est sur une seule ligne et defile : on ne touche pas
      if (grille.classList.contains('slider') && grille.scrollWidth > grille.clientWidth + 4) return;

      var hauts = cartes.map(function (c) { return Math.round(c.getBoundingClientRect().top); });
      var premier = hauts[0];
      var parLigne = hauts.filter(function (h) { return h === premier; }).length;
      if (parLigne < 2 || parLigne >= cartes.length) return;

      if (cartes.length % parLigne === 1) {
        cartes[cartes.length - 1].classList.add(MARQUE);
      }
    });
  }

  var minuteur = null;
  function rangerBientot() {
    clearTimeout(minuteur);
    minuteur = setTimeout(ranger, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ranger);
  } else {
    ranger();
  }
  // les images changent la hauteur des cartes : on recompte une fois posees
  window.addEventListener('load', ranger);
  window.addEventListener('resize', rangerBientot);
  // le theme recharge des sections en AJAX (filtres, panier) : on suit
  document.addEventListener('shopify:section:load', rangerBientot);
})();
